import { render, staticRenderFns } from "./SkuItem.vue?vue&type=template&id=a47812c4&scoped=true"
import script from "./SkuItem.vue?vue&type=script&lang=js"
export * from "./SkuItem.vue?vue&type=script&lang=js"
import style0 from "./SkuItem.vue?vue&type=style&index=0&id=a47812c4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a47812c4",
  null
  
)

export default component.exports